import { camelCase } from '@s-libs/micro-dash';
import ActionTracker from 'llt-action-tracker';
import { TrackEventArgsType, TrackEventNameType } from '../@types/schema';
import transformParams from './transform-params';

const getTrackingProperty = (el, propertyName) => {
  const matched = el.className.match(new RegExp(`js-${propertyName}:([^ ]+)`));
  return el.dataset[camelCase(propertyName)] || (matched && matched[1]);
};

/**
 * Helper function to raise a tracking event on the given DOM element.
 * @param el - The element to track
 * @param eventName - The name of the event
 * @param args - Any custom arguments to track
 */
export const raiseTrackingEvent = (el: Element, eventName: string, args?: any): CustomEvent => {
  const target = el.tagName;
  const className = el.className;
  const href = el.getAttribute('href');
  // TODO: const leadFormId = leadFormSelectors.getLeadFormId(this);
  // TODO: const panelId = leadFormSelectors.getLeadFormPanelId(this) || stepModel.getStepId(this);
  const text = (el.textContent || '').replace(/\s+/, ' ').trim();
  const category = getTrackingProperty(el, 'category') || 'nerdy-marketing';

  const eventArgs = {
    detail: {
      eventName,
      text,
      category,
      href,
      className,
      target,
      ...(args || {}),
    },
    bubbles: true,
  };

  const event = new CustomEvent('track', eventArgs);
  el.dispatchEvent(event);

  return event;
};

const defaultTracker = new ActionTracker({
  endpoint: process.env.NEXT_PUBLIC_ACTIONTRACKER_ENDPOINT,
  applicationId: process.env.NEXT_PUBLIC_ACTIONTRACKER_APPID,
});

/**
 * Tracks an event on the given tracker with the given args, performing transformation and adding
 * any extra necessary args based on the current document.
 */
export const track = async (
  eventName: TrackEventNameType,
  args: TrackEventArgsType,
  tracker = defaultTracker
) => {
  const transformed = transformParams(eventName, args);

  if (window['newrelic']) window['newrelic'].addPageAction(eventName, transformed);

  // this try catch exists because in localhost this will throw cors errors
  try {
    return await tracker.track(transformed);
  } catch (ex) {
    if (ex instanceof TypeError && process.env.NODE_ENV !== 'production') {
      return console.log('vt-events:', eventName, args);
    }
    return Promise.reject(ex);
  }
};
